import React, { useRef, useEffect, useState } from 'react';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const DEMO_USER_ID = 'f938b35d-537c-4398-8d0b-d32e9af9cbfc';

const C = {
  bg2:    '#0f1f38',
  border: '#1a2d47',
  accent: '#10b981',
  text:   '#f1f5f9',
  muted:  '#94a3b8',
  dim:    '#64748b',
  font:   "'Inter', system-ui, sans-serif",
};

const BG_IMG = 'https://images.unsplash.com/photo-1707361935112-9c1abbb9ae1f?auto=format&fit=crop&w=1600&q=80';
const BG_OVERLAY = 'linear-gradient(to bottom, rgba(5,10,20,0.30) 0%, rgba(5,10,20,0.28) 100%)';

function mdToHtml(text) {
  const esc = String(text || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
  return esc
    .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
    .replace(/\*(.+?)\*/g, '<em>$1</em>')
    .replace(/\n\n+/g, '<br><br>')
    .replace(/\n/g, '<br>');
}

// Read-only showcase of a real Data Coach conversation about the demo account's
// own game plans (stored in data_coach_chat_history for the demo user).
export default function DemoChatView() {
  const [messages, setMessages] = useState([]);
  const bottomRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    fetch(`${API}/data-coach/chat/history/${DEMO_USER_ID}`)
      .then(r => (r.ok ? r.json() : { messages: [] }))
      .then(d => { if (!cancelled) setMessages(d.messages || []); })
      .catch(e => console.error('[DemoChatView] chat history load failed:', e));
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'auto' });
  }, [messages]);

  return (
    <div style={{ position: 'relative', minHeight: 'calc(100vh - 60px)', fontFamily: C.font, display: 'flex', justifyContent: 'center' }}>
      <div style={{ position: 'fixed', inset: 0, zIndex: 0,
        backgroundImage: `url(${BG_IMG})`, backgroundSize: 'cover', backgroundPosition: 'center' }} />
      <div style={{ position: 'fixed', inset: 0, zIndex: 0, background: BG_OVERLAY }} />
    <div style={{
      position: 'relative', zIndex: 1,
      width: '100%', maxWidth: '760px',
      background: 'rgba(8,14,26,0.97)',
      borderLeft: '1px solid rgba(255,255,255,0.07)',
      borderRight: '1px solid rgba(255,255,255,0.07)',
      display: 'flex', flexDirection: 'column',
      height: 'calc(100vh - 120px)', minHeight: '400px',
      padding: '12px 16px 0',
    }}>
      {/* Messages */}
      <div style={{ flex: 1, overflowY: 'auto', paddingBottom: '8px' }}>
        {messages.map((m, i) => (
          <div key={i} style={{
            display: 'flex',
            justifyContent: m.role === 'user' ? 'flex-end' : 'flex-start',
            marginBottom: '12px',
          }}>
            <div style={{
              maxWidth: '78%', padding: '10px 14px', borderRadius: '14px',
              background: m.role === 'user' ? `${C.accent}1a` : C.bg2,
              border: `1px solid ${m.role === 'user' ? `${C.accent}44` : C.border}`,
              color: C.text, fontSize: '14px', lineHeight: 1.6,
              borderBottomRightRadius: m.role === 'user' ? '4px' : '14px',
              borderBottomLeftRadius:  m.role === 'user' ? '14px' : '4px',
            }}>
              <div style={{
                color: m.role === 'user' ? '#60a5fa' : '#34d399',
                fontWeight: 700, fontSize: 11, marginBottom: 5,
              }}>
                {m.role === 'user' ? 'You:' : 'Data Coach:'}
              </div>
              {m.role === 'user'
                ? m.content
                : <div dangerouslySetInnerHTML={{ __html: mdToHtml(m.content) }} />}
            </div>
          </div>
        ))}
        <div ref={bottomRef} />
      </div>

      {/* Demo input (disabled) */}
      <div style={{ paddingTop: '12px', borderTop: `1px solid ${C.border}` }}>
        <div style={{
          background: `${C.accent}0a`, border: `1px solid ${C.accent}30`,
          borderRadius: '8px', padding: '8px 12px', marginBottom: '10px',
          color: C.muted, fontSize: '12px', textAlign: 'center',
        }}>
          This is a demo conversation — create an account to chat with your own matches
        </div>
        <div style={{ display: 'flex', gap: '8px' }}>
          <div style={{
            flex: 1, background: C.bg2, border: `1px solid ${C.border}`,
            borderRadius: '10px', color: C.dim, fontSize: '14px',
            padding: '12px 14px', opacity: 0.5,
          }}>
            Ask your coach...
          </div>
          <div style={{
            background: C.bg2, border: 'none', borderRadius: '10px',
            width: '44px', display: 'flex', alignItems: 'center',
            justifyContent: 'center', fontSize: '18px', opacity: 0.3,
            color: C.text,
          }}>↑</div>
        </div>
      </div>
    </div>
    </div>
  );
}
